import { Admin, Resource, defaultTheme } from "react-admin";
import authProvider from "./components/Authentication/authProvider";
import Kitchens from "./components/Kitchens";
import Wardobes from "./components/Wardobes";
import Testimonials from "./components/Testimonials";
import Dashboard from "./components/Dashboard";
import { CustomLayout } from "./components/CustomLayout.js";
import KitchensPremium from "./components/KitchensPremium.js";
import KitchensEssentials from "./components/KitchensEssentials.js";
import KitchensLuxury from "./components/KitchensLuxury.js";
import { useEffect } from 'react';
import { toast } from "react-toastify";

const lightTheme = defaultTheme;
const darkTheme = { ...defaultTheme, palette: { mode: "dark" } };
const CURRENT_APP_VERSION = process.env.REACT_APP_VERSION;

// Clear session storage
sessionStorage.clear();

const App = () => {

  useEffect(() => {
    const checkVersionChange = () => {
      const storedVersion = localStorage.getItem("app_version");

      if (storedVersion && storedVersion !== CURRENT_APP_VERSION) {
        toast.info("New version detected. Reloading... Please wait.");
        setTimeout(() => {
          localStorage.setItem("app_version", CURRENT_APP_VERSION);
          window.location.reload(true);
        }, 3000);
      } else {
        localStorage.setItem("app_version", CURRENT_APP_VERSION);
      }
    };

    checkVersionChange(); // Run on first load
    const interval = setInterval(checkVersionChange, 1000); // 🔁 Every 1 hour

    return () => clearInterval(interval);
  }, []);

  return (
    <Admin
      theme={lightTheme}
      darkTheme={darkTheme}
      authProvider={authProvider}
      requireAuth
      layout={CustomLayout}
    >
      <Resource name="Dashboard" list={Dashboard} />
      <Resource
        name="Kitchens-Essentials"
        list={KitchensEssentials}
        options={{ label: 'Kitchens Essentials' }}
      />
      <Resource
        name="Kitchens-Premium"
        list={KitchensPremium}
        options={{ label: 'Kitchens Premium' }}
      />
      <Resource
        name="Kitchens-Luxury"
        list={KitchensLuxury}
        options={{ label: 'Kitchens luxury' }}
      />
      <Resource
        name="Kitchens-Space-Fit"
        list={Kitchens}
        options={{ label: 'Kitchens Spacefit' }}
      />
      <Resource name="Wardobes" list={Wardobes} options={{ label: 'Wardobes Spacefit' }} />
      <Resource name="Testimonials" list={Testimonials} />
    </Admin>
  );
};

export default App;